module.exports = __webpack_public_path__ + "img/is_children_allowed.146f646e.webp";